import { useEffect, useState, useRef } from "react";
import { ChakraCollapse as Collapse, ChakraButton as Button, ChakraBox as Box } from "@airhelp/react-ui-components";
import type { CollapsibleTextProps } from "./ReviewCard.d";

const COLLAPSE_HEIGHT = 72;

export const CollapsibleText = ({ text = "" }: CollapsibleTextProps) => {
  const [reviewTextVisible, setReviewTextVisible] = useState(true);
  const reviewTextRef = useRef(null);

  useEffect(() => {
    if (reviewTextRef.current.clientHeight > COLLAPSE_HEIGHT) {
      setReviewTextVisible(false);
    }
  }, []);

  const handleToggle = () => setReviewTextVisible(!reviewTextVisible);

  return (
    <Box textAlign="left">
      <Collapse ref={reviewTextRef} startingHeight={COLLAPSE_HEIGHT} in={reviewTextVisible}>
        {text}
      </Collapse>
      {!reviewTextVisible && (
        <Button minWidth="initial" variant="link" onClick={handleToggle} minHeight="fit-content">
          ...
        </Button>
      )}
    </Box>
  );
};
